class VideoModal {
  constructor() {
    this.modal = document.getElementById('videoModal');
    this.modalVideo = document.getElementById('modalVideo');
    this.modalTitle = document.getElementById('videoModalTitle');
    this.isOpen = false;
    this.previousFocus = null;
    this.allVideoTriggers = [];
    this.currentVideoIndex = 0;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.minSwipeDistance = 50;
    this.init();
  }

  init() {
    if (!this.modal || !this.modalVideo) return;
    this.bindEvents();
  }

  isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  bindEvents() {
    const closeButtons = this.modal.querySelectorAll('[data-video-modal-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    const prevButton = document.getElementById('videoModalPrev');
    const nextButton = document.getElementById('videoModalNext');
    
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToPrevious();
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToNext();
      });
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-video-modal-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.handleVideoClick(trigger);
        
        if (this.isIOS()) {
          setTimeout(() => {
            this.tryPlayAfterUserInteraction();
          }, 500);
        }
      }
    });

    document.addEventListener('keydown', (e) => {
      if (this.isOpen) {
        switch(e.key) {
          case 'Escape':
            e.preventDefault();
            this.close();
            break;
          case 'ArrowLeft':
            e.preventDefault();
            this.goToPrevious();
            break;
          case 'ArrowRight':
            e.preventDefault();
            this.goToNext();
            break;
          case ' ':
          case 'k':
            if (e.target === this.modalVideo) {
              e.preventDefault();
              this.togglePlayPause();
            }
            break;
        }
      }
    });

    this.bindTouchEvents();
  }

  bindTouchEvents() {
    if (!this.modal) return;

    this.modal.addEventListener('touchstart', (e) => {
      if (!this.isOpen) return;
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    }, { passive: true });

    this.modal.addEventListener('touchend', (e) => {
      if (!this.isOpen) return;
      this.touchEndX = e.changedTouches[0].clientX;
      this.touchEndY = e.changedTouches[0].clientY;
      this.handleSwipe();
    }, { passive: true });

    let isDragging = false;
    let mouseStartX = 0;

    this.modal.addEventListener('mousedown', (e) => {
      if (!this.isOpen || e.target.closest('video, button, a')) return;
      isDragging = true;
      mouseStartX = e.clientX;
      this.modal.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });

    document.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      this.modal.style.cursor = '';
      
      const mouseEndX = e.clientX;
      const deltaX = mouseStartX - mouseEndX;
      
      if (Math.abs(deltaX) > this.minSwipeDistance) {
        if (deltaX > 0) {
          this.goToNext();
        } else {
          this.goToPrevious();
        }
      }
    });
  }

  handleSwipe() {
    const deltaX = this.touchStartX - this.touchEndX;
    const deltaY = this.touchStartY - this.touchEndY;
    
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
      if (deltaX > 0) {
        this.goToNext();
      } else {
        this.goToPrevious();
      }
    }
  }

  handleVideoClick(trigger) {
    this.allVideoTriggers = Array.from(document.querySelectorAll('[data-video-modal-trigger]'));
    this.currentVideoIndex = this.allVideoTriggers.indexOf(trigger);
    this.openCurrentVideo();
  }

  openCurrentVideo() {
    const trigger = this.allVideoTriggers[this.currentVideoIndex];
    if (!trigger) return;

    const videoElement = trigger.querySelector('.social-proof__video-element');
    if (!videoElement) return;

    let videoSrc = videoElement.src || videoElement.currentSrc;
    
    if (!videoSrc) {
      const sourceElement = videoElement.querySelector('source');
      if (sourceElement) {
        videoSrc = sourceElement.src;
      }
    }

    const productData = {
      title: trigger.getAttribute('data-product-title'),
      price: trigger.getAttribute('data-product-price'),
      comparePrice: trigger.getAttribute('data-product-compare-price'),
      url: trigger.getAttribute('data-product-url'),
      image: trigger.getAttribute('data-product-image')
    };

    if (videoSrc) {
      if (this.isOpen) {
        this.updateModalContent(videoSrc, productData);
      } else {
        this.open(videoSrc, productData);
      }
    }
  }

  updateModalContent(videoSrc, productData) {
    this.modalVideo.pause();
    this.modalVideo.src = videoSrc;
    
    const productInfo = document.getElementById('videoModalProductInfo');
    const defaultTitle = document.getElementById('videoModalDefaultTitle');
    
    if (productData && productData.title) {
      document.getElementById('videoModalTitle').textContent = productData.title;
      document.getElementById('videoModalPrice').textContent = productData.price || '';
      
      const productLink = document.getElementById('videoModalProductLink');
      if (productData.url) {
        productLink.href = productData.url;
        productLink.style.cursor = 'pointer';
      } else {
        productLink.href = '#';
        productLink.style.cursor = 'default';
      }
      
      const comparePrice = document.getElementById('videoModalComparePrice');
      if (productData.comparePrice) {
        comparePrice.textContent = productData.comparePrice;
        comparePrice.style.display = 'inline';
      } else {
        comparePrice.style.display = 'none';
      }
      
      const productImage = document.getElementById('videoModalProductImage');
      if (productData.image) {
        productImage.src = productData.image;
        productImage.alt = productData.title;
        productImage.width = 50;
        productImage.height = 50;
      }
      
      productInfo.style.display = 'flex';
      defaultTitle.style.display = 'none';
    } else {
      productInfo.style.display = 'none';
      defaultTitle.style.display = 'block';
    }

    this.updateNavigationControls();
    
    if (this.isIOS()) {
      this.modalVideo.addEventListener('loadeddata', () => {}, { once: true });
    } else {
      const playVideo = () => {
        this.modalVideo.play().catch(() => {});
      };
      
      if (this.modalVideo.readyState >= 2) {
        playVideo();
      } else {
        this.modalVideo.addEventListener('loadeddata', playVideo, { once: true });
      }
    }
  }

  open(videoSrc, productData = null) {
    if (this.isOpen) return;

    this.previousFocus = document.activeElement;
    this.isOpen = true;
    this.modalVideo.src = videoSrc;
    
    if (this.isIOS()) {
      this.modalVideo.addEventListener('loadeddata', () => {}, { once: true });
    } else {
      this.modalVideo.addEventListener('loadeddata', () => {
        this.modalVideo.play().catch(() => {});
      }, { once: true });
    }

    const productInfo = document.getElementById('videoModalProductInfo');
    const defaultTitle = document.getElementById('videoModalDefaultTitle');
    
    if (productData && productData.title) {
      document.getElementById('videoModalTitle').textContent = productData.title;
      document.getElementById('videoModalPrice').textContent = productData.price || '';
      
      const productLink = document.getElementById('videoModalProductLink');
      if (productData.url) {
        productLink.href = productData.url;
        productLink.style.cursor = 'pointer';
      } else {
        productLink.href = '#';
        productLink.style.cursor = 'default';
        productLink.addEventListener('click', (e) => e.preventDefault());
      }
      
      const comparePrice = document.getElementById('videoModalComparePrice');
      if (productData.comparePrice) {
        comparePrice.textContent = productData.comparePrice;
        comparePrice.style.display = 'inline';
      } else {
        comparePrice.style.display = 'none';
      }
      
      const productImage = document.getElementById('videoModalProductImage');
      if (productData.image) {
        productImage.src = productData.image;
        productImage.alt = productData.title;
        productImage.width = 50;
        productImage.height = 50;
      }
      
      productInfo.style.display = 'flex';
      defaultTitle.style.display = 'none';
    } else {
      productInfo.style.display = 'none';
      defaultTitle.style.display = 'block';
    }

    this.updateNavigationControls();
    this.modal.classList.add('video-modal--active');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      this.modalVideo.focus();
    }, 100);

    this.pauseAllVideos();
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.modal.classList.remove('video-modal--active');
    this.modal.setAttribute('aria-hidden', 'true');
    this.modalVideo.pause();
    this.modalVideo.src = '';
    document.body.style.overflow = '';
    if (this.previousFocus) {
      this.previousFocus.focus();
      this.previousFocus = null;
    }
  }

  togglePlayPause() {
    if (this.modalVideo.paused) {
      this.modalVideo.play().catch(() => {});
    } else {
      this.modalVideo.pause();
    }
  }

  pauseAllVideos() {
    const allVideos = document.querySelectorAll('video');
    allVideos.forEach(video => {
      if (video !== this.modalVideo && !video.paused) {
        video.pause();
      }
    });
  }

  updateNavigationControls() {
    const prevButton = document.getElementById('videoModalPrev');
    const nextButton = document.getElementById('videoModalNext');
    const swipeIndicator = document.getElementById('videoModalSwipeIndicator');
    
    if (this.allVideoTriggers.length <= 1) {
      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
      if (swipeIndicator) swipeIndicator.style.display = 'none';
      this.modal.classList.add('video-modal--single-video');
    } else {
      if (prevButton) {
        prevButton.style.display = 'flex';
        prevButton.disabled = this.currentVideoIndex === 0;
      }
      if (nextButton) {
        nextButton.style.display = 'flex';
        nextButton.disabled = this.currentVideoIndex === this.allVideoTriggers.length - 1;
      }
      if (swipeIndicator) swipeIndicator.style.display = 'flex';
      this.modal.classList.remove('video-modal--single-video');
    }
  }

  goToPrevious() {
    if (this.currentVideoIndex > 0) {
      this.currentVideoIndex--;
      this.openCurrentVideo();
    }
  }

  goToNext() {
    if (this.currentVideoIndex < this.allVideoTriggers.length - 1) {
      this.currentVideoIndex++;
      this.openCurrentVideo();
    }
  }

  tryPlayAfterUserInteraction() {
    if (this.isOpen && this.modalVideo) {
      this.modalVideo.play().catch(() => {});
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.videoModal = new VideoModal();
  });
} else {
  window.videoModal = new VideoModal();
}
